<template>
  <el-dialog
    class="dialog-selgoods-multiple"
    :title="`选择${decorationShopType == 4 || goodsShopType == 4 ? '服务' : '商品'}`"
    :visible.sync="showDialog"
    :before-close="beforeClose"
  >
    <div class="content-page">
      <div class="bd">
        <div class="tab-header">
          <div class="header-right">
            <el-cascader
              v-model="categoryCascaderValue"
              :options="categoryCascaderOptions"
              :props="categoryCascaderProps"
              clearable
              filterable
              size="small"
              placeholder="请选择分类"
              @change="handleCategoryChange"
            ></el-cascader>
            <el-input
              :placeholder="`请输入${
                decorationShopType == 4 || goodsShopType == 4 ? '服务' : '商品'
              }...`"
              v-model.trim="searchInput"
              class="input-search"
              size="small"
              @keyup.enter.native="searchGoods"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchGoods"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div class="tab-content">
          <div class="goods-list">
            <el-checkbox-group v-model="checkedGoodsList" @change="checkedGoodsChange">
              <el-table :data="goodsList" style="width: 100%">
                <el-table-column
                  :label="`${
                    decorationShopType == 4 || goodsShopType == 4 ? '服务' : '商品'
                  }`"
                >
                  <template slot-scope="scope">
                    <el-checkbox
                      :label="scope.row.goodsId"
                      :disabled="
                        checkedGoodsList.length >= limitNum &&
                        !checkedGoodsList.includes(scope.row.goodsId)
                          ? true
                          : false
                      "
                    >
                      <div class="goods-info">
                        <el-image
                          class="pic"
                          :src="scope.row.goodsImage || defaultImg"
                          fit="fill"
                          :class="{
                            'lower-shelf': !scope.row.saleStatus,
                            'will-sell-out':
                              scope.row.totalStockCount > 1 &&
                              scope.row.totalStockCount <= 10 &&
                              scope.row.saleStatus,
                            'sell-out':
                              scope.row.totalStockCount <= 0 && scope.row.saleStatus,
                          }"
                        ></el-image>
                        <div class="info">
                          <div class="title">
                            {{ scope.row.goodsName }}
                            <div class="tag-list">
                              <span v-if="scope.row.unitType == 2">计重</span>
                            </div>
                          </div>
                          <p class="price">￥{{ scope.row.retailPrice }}</p>
                        </div>
                      </div>
                    </el-checkbox>
                  </template>
                </el-table-column>
              </el-table>
            </el-checkbox-group>
            <div class="list-footer">
              <el-checkbox
                :indeterminate="goodsIsIndeterminate"
                v-model="goodsAllChecked"
                @change="handleCheckAllChange"
                size="medium"
                >全选</el-checkbox>
              <el-pagination
                @current-change="handleCurrentChange"
                :page-size="row"
                :current-page="pageNo"
                background
                layout="total, prev, pager, next"
                :total="total"
              ></el-pagination>
              <el-button type="primary" size="medium" @click="confirmAdd">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getFindAllGoodsPlus, findGoodsNum } from "@/api/index";
import { mapState, mapActions } from "vuex";
import {
  getCategoryIdFromCascader,
  loadSecondaryCategoryForCascader,
  toCategoryCascaderOptions,
} from "@/utils/secondaryCategory";
export default {
  data() {
    return {
      showDialog: false,
      goodsList: [],
      pageNo: 1,
      row: 10,
      total: 0,
      goodsCategoryId: "",
      categoryCascaderValue: [],
      checkedGoodsList: [],
      searchInput: "",
      goodsAllChecked: false,
      goodsIsIndeterminate: false,
      defaultImg: require("@/assets/img/common/default-img.jpg"),
      goodsDataMap: {},
    };
  },
  props: {
    limitNum: {
      type: Number,
      default: Infinity,
    },
    goodsShopType: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    goodsCategoryId() {
      this.getPageData();
    },
    checkedGoodsList(val) {
      val.forEach((val) => {
        if (!this.goodsDataMap[val]) {
          let goodsIndex = this.goodsList.findIndex((goods) => {
            return goods.goodsId == val;
          });
          this.goodsDataMap[val] = this.goodsList[goodsIndex];
        }
      });
      console.log(this.goodsDataMap);
    },
  },
  computed: {
    ...mapState({
      goodsCategorys: (state) => state.goodsCategorys,
      decorationShopType: (state) => state.decorationShopType,
    }),
    goodsListOptions() {
      let options = [];
      this.goodsList.forEach((val) => {
        options.push(val.goodsId);
      });
      return options;
    },
    categoryCascaderOptions() {
      if (this.goodsCategorys.length) {
        return toCategoryCascaderOptions(this.goodsCategorys);
      }
      this.updateDecorationShopType(this.goodsShopType);
      this.updateGoodsCategorys();
      return [];
    },
    categoryCascaderProps() {
      return {
        checkStrictly: true,
        emitPath: true,
        lazy: true,
        lazyLoad: this.loadCategoryCascader,
      };
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["updateGoodsCategorys", "updateDecorationShopType"]),
    loadCategoryCascader(node, resolve) {
      loadSecondaryCategoryForCascader(
        node,
        resolve,
        1000,
        this.decorationShopType == 4 || this.goodsShopType == 4
          ? { categoryNatureType: 2 }
          : {}
      );
    },
    handleCategoryChange(value) {
      this.goodsCategoryId = getCategoryIdFromCascader(value);
    },
    openDialog(list = []) {
      console.log(list);
      this.checkedGoodsList = list;
      this.checkedGoodsChange(this.checkedGoodsList);
      this.showDialog = true;
    },
    // 确定
    confirmAdd() {
      let goodsList = this.removeDuplicate(this.checkedGoodsList);
      console.log(goodsList, "checkedGoodsList");
      if (goodsList.length <= 0) {
        this.$notify({
          title: "提示",
          message: `请选择${
            this.decorationShopType == 4 || this.goodsShopType == 4 ? "服务" : "商品"
          }`,
          type: "warning",
          duration: 1000,
        });
        return;
      }
      let list = [];
      goodsList.forEach((val) => {
        list.push(this.goodsDataMap[val]);
      });
      this.$emit("confirmSelGoods", list);
      this.showDialog = false;
    },
    removeDuplicate(arr) {
      return arr.filter((item, index) => {
        return arr.indexOf(item) === index;
      });
    },
    getPageData() {
      this.pageNo = 1;
      this.findGoodsNum();
      this.getFindAllGoodsPlus();
    },
    findGoodsNum() {
      findGoodsNum({
        saleStatus: 1,
        pageNo: this.pageNo,
        row: this.row,
        goodsName: this.searchInput,
        goodsCategoryId: this.goodsCategoryId,
        goodsNatureType: this.decorationShopType == 4 || this.goodsShopType == 4 ? 2 : 1,
      }).then((res) => {
        if (res.code == 1) {
          this.total = res.data;
        } else {
          this.total = 0;
        }
      });
    },
    // 商品列表
    getFindAllGoodsPlus() {
      getFindAllGoodsPlus({
        saleStatus: 1,
        pageNo: this.pageNo,
        row: this.row,
        goodsName: this.searchInput,
        goodsCategoryId: this.goodsCategoryId,
        goodsNatureType: this.decorationShopType == 4 || this.goodsShopType == 4 ? 2 : 1,
      }).then((res) => {
        if (res.code == 1) {
          this.goodsList = res.data;
          this.checkedGoodsChange(this.checkedGoodsList);
        } else {
          this.goodsList = [];
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getFindAllGoodsPlus();
    },
    searchGoods() {
      this.getPageData();
    },
    checkedGoodsChange(value) {
      console.log(value);
      // if (this.limitNum !== Infinity) {
      //   if (this.checkedGoodsList.length > this.limitNum) {
      //     this.checkedGoodsList.splice(
      //       this.checkedGoodsList.length,
      //       this.checkedGoodsList.length - this.limitNum
      //     );
      //   }
      // }
      let checkedCount = 0;
      this.goodsList.forEach((val) => {
        if (value.indexOf(val.goodsId) > -1) {
          checkedCount++;
        }
      });
      this.goodsAllChecked = checkedCount === this.goodsList.length;
      this.goodsIsIndeterminate =
        checkedCount > 0 && checkedCount < this.goodsList.length;
      console.log(this.goodsIsIndeterminate, checkedCount, this.goodsList.length);
    },
    handleCheckAllChange(val) {
      if (this.limitNum !== Infinity) {
        this.goodsAllChecked = false;
        return this.$notify({
          title: "提示",
          message: `只能选择${this.limitNum}个${
            this.decorationShopType == 4 || this.goodsShopType == 4 ? "服务" : "商品"
          }，请手动选择`,
          type: "warning",
          duration: 2000,
        });
      }
      if (!this.checkedGoodsList.length) {
        this.checkedGoodsList = val ? this.goodsListOptions : [];
      } else {
        console.log(val);
        if (val) {
          this.checkedGoodsList = this.checkedGoodsList.concat(this.goodsListOptions);
        } else {
          this.checkedGoodsList = this.checkedGoodsList.filter((val) => {
            return !this.goodsListOptions.includes(val);
          });
        }
      }
      this.goodsIsIndeterminate = false;
    },
    beforeClose() {
      this.$emit("hideSelGoods");
      this.showDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-selgoods-multiple {
  .content-page {
    overflow: hidden;
    .bd {
      height: 100%;
      &.sort {
        height: 100%;
        overflow-y: scroll;
        .tab-header {
          background: #fffcf5;
          border-bottom-color: #f2e7b8;
          padding: 10px;
        }
        .tab-content {
          .goods-list {
            width: 100%;
          }
        }
      }
    }
    .tab-header {
      .header-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .el-cascader {
          width: 240px;
          margin-right: 10px;
        }
      }
      .btn-group-one {
        .upload-xls {
          display: inline-block;
          margin: 0 15px;
        }
      }
      .btn-group-two {
        .el-checkbox {
          margin-right: 15px;
        }
      }
    }
    .tab-content {
      padding: 0;
      height: 500px;
    }
    .tab-footer {
      text-align: center;
      margin: 10px 0;
      .el-button {
        margin-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
    }
    .goods-list {
      width: 100%;
      min-width: 100%;
      box-sizing: border-box;
      .list-title {
        display: flex;
        padding: 0 20px 0 0;
        line-height: 40px;
        background: #f8f8f8;
        .title {
          box-sizing: border-box;
          padding-left: 10px;
          flex: 1;
          &:first-of-type {
            min-width: 400px;
            max-width: 400px;
            padding-left: 40px;
          }
        }
      }
      .el-checkbox-group {
        height: calc(100% - 51px);
        overflow: auto;
      }
      .search-header {
        line-height: 30px;
        margin: 10px 0;
        font-size: 14px;
        color: #333;
        padding-left: 10px;
        .el-link {
          vertical-align: top;
          line-height: 30px;
          margin-left: 20px;
        }
      }
      &.screen {
        width: 100%;
      }
      .list-footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0 0 10px;
      }
      .goods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
      }
      .goods-info {
        display: flex;
        &.active {
          background: #f5f7fa;
        }
        .pic {
          position: relative;
          width: 50px;
          height: 50px;
          border-radius: 4px;
          &::before {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            line-height: 50px;
            font-size: 12px;
          }
          &.lower-shelf {
            &::before {
              content: "已下架";
            }
          }
          &.sell-out {
            &::before {
              content: "已售罄";
            }
          }
          &.will-sell-out {
            &::before {
              content: "将售罄";
            }
          }
        }
        .info {
          margin-left: 15px;
          .title {
            font-size: 14px;
            line-height: 28px;
            color: #666666;
            .tag-list {
              display: inline-block;
              & > span {
                background: #ee3030;
                color: #fff;
                font-size: 12px;
                border-radius: 3px;
                padding: 0 5px;
              }
            }
          }
          .price {
            font-size: 14px;
            line-height: 22px;
            color: #ee3030;
          }
        }
      }
      .table-action {
        & > span {
          margin: 0 10px;
        }
      }
      .list-none {
        text-align: center;
        font-size: 14px;
        color: #999999;
        padding-top: 200px;
        & > p {
          margin: 10px 0;
        }
      }
    }
  }
}
</style>

<style lang="less">
.dialog-selgoods-multiple {
  .el-dialog__body {
    padding-top: 10px;
  }
}
</style>

